---
title: Open engineering
slug: open-source
type: work
status: published
featured: true
summary: Public work lives mainly under the ecogenetic GitHub organization — runtime, algorithms, ontology catalog, docs, and starter apps.
sitePublishedAt: "2026-09-18"
lastReviewedAt: "2026-10-01"
audiences:
  - product-developer
themes:
  - prediction-in-production
  - platform-architecture
sourceUrl: https://github.com/ecogenetic
originalAuthor: Jay van Zyl
sourceRelationship: curated map of public first-party repositories
rightsStatus: first-party
seoDescription: Public code under ecogenetic, jayvanzyl, and ecosystemai.
canonicalPath: /work/open-source
---

Most of the interesting public code is under **[ecogenetic](https://github.com/ecogenetic)** (Ecogenetic LLC), not the personal account. The org line is “Bridge the gap between AI and the human in the system.”

The production server, workbench, runtime, data agents, and modeling app are the private counterparts of what this page lists. What you can inspect is the runtime architecture, algorithm notebooks, domain catalog, install path, CLI, and starter apps that call the pulse responder.

## Why these repos

- **Runtime** — [ecosystem-runtime-localbuild](https://github.com/ecogenetic/ecosystem-runtime-localbuild) is the public Pulse Responder: plugins, scoring, response tracking.
- **Algorithms** — [ecosystem-algorithms](https://github.com/ecogenetic/ecosystem-algorithms) holds notebooks and prediction-story templates.
- **Ontology** — [ecosystem-domain-catalog](https://github.com/ecogenetic/ecosystem-domain-catalog) seeds OWL/SKOS/SHACL domains for EcosystemCode.
- **Docs** — [ecosystem.ai](https://github.com/ecogenetic/ecosystem.ai) is the source for [developer.ecosystem.ai](https://developer.ecosystem.ai).
- **Deploy** — [ecosystem](https://github.com/ecogenetic/ecosystem) and [ecosystem-cli](https://github.com/ecogenetic/ecosystem-cli) for local install and operations.
- **Examples** — Angular, Python, and iOS message apps that call the runtime.

The personal account [jayvanzyl](https://github.com/jayvanzyl) holds RecSys 2019 bandit research forks (`kNNBandit`, `EnsembleBandits`). They are algorithm lineage, not the product. The [ecosystemai](https://github.com/ecosystemai) user is a pointer account that pins the org.
